import {CalendarActionType, CalendarState} from "./types";

const initialState: CalendarState = {
    allCountries: [],
    allCities: [],
    calendar: null,
    yearCalendar: null,
    postPracticeCalendar: null,
    loading: false,
    message: "",
};
const CalendarReducer = (state = initialState, action: any): CalendarState => {
    switch (action.type) {
        case CalendarActionType.START_REQUEST:
            return { ...state, loading: true };
        case CalendarActionType.ALL_COUNTRIES_LOADED:
            return { ...state, loading: false, allCountries: action.payload };
        case CalendarActionType.ALL_CITY_LOADED:
            return { ...state, loading: false, allCities: action.payload };
        case CalendarActionType.CALENDAR_LOADED_FROM_LOCAL_STORAGE:
            return { ...state, loading: false, calendar: action.payload };
        case CalendarActionType.CALENDAR_LOADED: {
            const mergedArray = [...(state.calendar ? state.calendar.days : []), ...action.payload.days].reduce((acc, obj) => {
                const key = `${obj.date.day}-${obj.date.month}-${obj.date.year}`;
                acc.set(key, obj);
                return acc;
            }, new Map());
            action.payload.days = Array.from(mergedArray.values());

            const now = new Date();
            const minDate = new Date(now.getFullYear(), now.getMonth() - 5, 1);
            const maxDate = new Date(now.getFullYear(), now.getMonth() + 7, 0);

            let filtered = structuredClone(action.payload);
            filtered.days = filterDatesBetween(filtered.days, minDate, maxDate);
            localStorage.setItem(action.payload.location.name, JSON.stringify(filtered));

            return {...state, loading: false, calendar: action.payload };
        }
        case CalendarActionType.YEAR_CALENDAR_LOADED: {
            return {...state, loading: false, yearCalendar: action.payload };
        }
        case CalendarActionType.POST_PRACTICE_CALENDAR_LOADED: {
            return {...state, loading: false, postPracticeCalendar: action.payload };
        }
        case CalendarActionType.FINISH_REQUEST:
            return { ...state, loading: false };
        default:
            return state;
    }
};

function filterDatesBetween(objects: any, minDate: Date, maxDate: Date) {
    return objects.filter((obj: any) => {
        const date = new Date(
            obj.date.year,
            obj.date.month - 1,
            obj.date.day,
        );
        return date >= minDate && date <= maxDate;
    });
}

export default CalendarReducer;
